import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'suzy-action-forms-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent {
  @Input() url: string = '';

  constructor(private activeModal: NgbActiveModal) {}

  closeModal() {
    this.activeModal.dismiss();
  }
}
